<template>
  <div class="card">
    <div
      v-b-toggle="`collapseCourse`"
      class="card-header"
    >
      <h3
        :id="`field-7`"
        class="cart-title"
      >
        <a data-action="collapse">{{ field.label ? field.label : field.name }}</a>
      </h3>
      <b-tooltip
        :key="`field-custom-7`"
        placement="topleft"
        boundary="document"
        triggers="hover"
        :target="`field-7`"
        :title="field.tooltip"
      />
      <div class="heading-elements">
        <ul class="list-inline mb-0">
          <li>
            <a data-action="collapse"><i data-feather="chevron-down" /></a>
          </li>
          <!-- <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Edit"
              @click="redirectuser($event, [{user_id: userId}, 'researcher.courses.index'])"
            ><i data-feather="edit-3" /></a>
          </li> -->
        </ul>
      </div>
    </div>
    <b-collapse
      :id="`collapseCourse`"
      v-model="isToggled"
    >
      <div
        class="card-content"
      >
        <div class="card-body">
          <div
            v-if="loading"
            class="loading position-relative"
          >
            <div class="effect-1 effects" />
            <div class="effect-2 effects" />
            <div class="effect-3 effects" />
          </div>
          <div
            v-else
            class="row"
          >
            <div class="col">
              <div v-if="fromPromotion && convo.days > 0 && isResearcher" class="mb-2">
                <div class="form-check form-switch form-check-inline me-2">
                  <input id="selectAllCourses" class="form-check-input" type="checkbox" :checked="allCoursesSelected" @change="toggleSelectAllCourses">
                  <label class="form-check-label" for="selectAllCourses">Select all</label>
                </div>
              </div>
              <hr>
              <ul
                v-for="course in filteredCourses"
                :key="course.id"
                class="abridged-cv__list"
              >
                <li>
                  <div
                    v-if="fromPromotion && convo.days > 0 && isResearcher"
                    class="form-check form-switch form-check-inline me-2"
                  >
                    <input
                      :id="'activityContent' + course.id"
                      type="checkbox"
                      class="form-check-input"
                      :checked="selectedActivities.includes(course.id.toString())"
                      @change="handleActivityClick(course, $event)"
                    >
                  </div>
                  <strong>{{ course.date_formatted }} - {{ course.end_date_formatted }}</strong>
                  ({{ course.content_formatted.course_type ? course.content_formatted.course_type.name : ' --' }}), "{{ course.content_formatted.title }}"
                  {{ course.address }}{{ course.content_formatted.host_name ? `, ${course.content_formatted.host_name}` : '' }}{{ course.country ? `, ${course.country}` : '' }} {{ course.content_formatted.virtual_activity ? '(online)' : '' }}
                  <a
                    class="ms-1 btn btn-sm bg-light-secondary"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Edit"
                    @click="redirectuser($event, [{ id: course.id }, 'researcher.courses.edit'])"
                  ><i data-feather="edit-3" /></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BCollapse, BTooltip } from 'bootstrap-vue'

export default {
  components: {
    BCollapse,
    BTooltip,
  },
  props: {
    userId: { type: Number, required: true, default: () => {} },
    yearBetween: { type: Object, required: true, default: () => {} },
    field: { type: Object, required: true },
    promo: { type: Object, required: false, default: () => {} },
    fromPromotion: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      loading: true,
      isToggled: true,
      type: 'courses',
      optimisticSelectedActivities: new Set(),
    }
  },
  computed: {
    ...mapGetters({
      scientificCourses: 'users/scientificCourses',
      selectedActivities: 'convo/selectedActivities',
      toggled: 'preview/toggled',
      convo: 'convo/convo',
      loggedUser: 'auth/admin',
    }),
    isResearcher() {
      return this.loggedUser.roles.includes('researcher')
    },
      visibleCourses() {
        return (this.filteredCourses || []).map(c => c)
      },
      visibleCourseIds() {
        return this.visibleCourses.map(c => c.id?.toString()).filter(Boolean)
      },
      allCoursesSelected() {
        const ids = this.visibleCourseIds
        return ids.length > 0 && ids.every(id => this.selectedActivities.includes(id) || this.optimisticSelectedActivities.has(id))
      },
    filteredCourses() {
      if (this.loggedUser.roles.includes('super-admin') && (!this.fromPromotion || this.convo.year < 2026)) {
        return this.scientificCourses
      }

      if (this.isResearcher && (!this.fromPromotion || this.convo.year < 2026 || this.convo.days > 0)) {
        return this.scientificCourses
      }
      // For non-researchers or when in promotion mode with days <= 0, only show selected courses
      return this.scientificCourses.filter(course => this.selectedActivities.includes(course.id.toString()))
    },
  },
  watch: {
    userId() {
      this.reloadData()
    },
    toggled() {
      if (this.toggled !== this.isToggled) {
        this.isToggled = this.toggled
      }
    },
    yearBetween() {
      this.reloadData()
    },
    selectedActivities() {
      this.optimisticSelectedActivities = new Set()
    },
  },
  async mounted() {
    this.reloadData()
    if (this.fromPromotion) {
      this.loadSelectedActivities()
    }
  },
  methods: {
    async reloadData() {
      this.loading = true
      this.isToggled = this.toggled
      if (this.promo && this.promo.id && !this.promo.active_researcher) {
        await this.$store.dispatch('users/fetchUserScientificActivitiesFreezed', {
          convo: this.promo.id, userId: this.userId, yearBetween: this.yearBetween, type: this.type,
        })
      } else {
        await this.$store.dispatch('users/fetchUserScientificActivities', { userId: this.userId, yearBetween: this.yearBetween, type: this.type })
      }
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 500)
      this.loading = false
    },
    async redirectuser(event, redirection) {
      event.stopPropagation()
      this.$emit('goToIndex', redirection)
    },

    handleActivityClick(activity, event) {
      const isChecked = event.target.checked
      const isCurrentlySelected = this.selectedActivities.includes(activity.id.toString())
      const promotionDataId = isCurrentlySelected ? activity.pivot?.id : null

      this.$emit('item-selected', {
        id: promotionDataId || null,
        origenable_id: activity.id,
        type: 'App\\Models\\Activity',
        selected: isChecked,
      })
    },

    toggleSelectAllCourses() {
      const allSelected = this.allCoursesSelected
      for (const activity of this.filteredCourses || []) {
        this.$emit('item-selected', {
          id: allSelected ? (activity.pivot?.id || null) : null,
          origenable_id: activity.id,
          type: 'App\\Models\\Activity',
          selected: !allSelected,
        })
      }
      if (!allSelected) {
        this.optimisticSelectedActivities = new Set(this.visibleCourseIds)
      } else {
        this.optimisticSelectedActivities = new Set()
      }

      setTimeout(async () => {
        await this.loadSelectedActivities()
      }, 1000)
    },

    async loadSelectedActivities() {
      if (!this.fromPromotion) return

      try {
        await this.$store.dispatch('convo/fetchSelectedPromotionScientificProductions', {
          origenableType: 'App\\Models\\Activity',
          userId: this.userId,
        })
      } catch (error) {
        console.error('Error loading selected activities:', error)
      }
    },
  },
}
</script>

<style scoped>
.abridged-cv__list {
  list-style-type: none;
  padding-left: 0;
}

.form-check-inline {
  margin-right: 0.5rem;
}
</style>
